import _ from 'lodash'
import moment from 'moment'
import {useEffect, useState} from 'react'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import {useDispatch, useSelector} from 'react-redux'
import {
  CompanyMonthlyDocumentInfo,
  CompanyMonthlyDocumentRequest,
  CompanyMonthlyDocumentsPageDTO,
  CompanyMonthlyDocumentsPageDTOApiData,
} from '../../../api/data-contracts'
import {Api_Admin_GetMonthlyDocumentsPageData} from '../../../apiClient/apiClient'
import {getAdminState} from '../../../redux/adminSlice'
import {postRequestAsync} from '../../../redux/commonSlice'
import {Field} from 'formik'
import FormikForm from '../../../components/form/FormikForm'
import BasePopup, {PopupProvides} from '../../../components/common/popup/BasePopup'
import FileUploadForm from '../../../components/document/FileUploadForm'
import filterFactory, {selectFilter} from 'react-bootstrap-table2-filter'

function MonthlyDocumentReportPage() {
  const initFilterValues: CompanyMonthlyDocumentRequest = {
    month: moment(new Date()).startOf('month').format('yyyy-MM-DD'),
  }
  const dispatch = useDispatch()

  const [report, setReport] = useState<CompanyMonthlyDocumentsPageDTO | null | undefined>()

  const columns: ColumnDescription[] = [
    {
      dataField: 'companyName',
      text: 'Firma',
      sort: true,
      headerStyle: {width: '30%', verticalAlign: 'middle'},
      // headerClasses: 'd-flex align-items-center h-100',
      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6'>{m.companyName}</div>
        </>
      ),
    },
    {
      dataField: 'isDeclarationDocumentUploaded',
      text: 'Beyanname Yüklendi',
      sort: true,
      headerStyle: {width: '20%'},
      headerFormatter: (column, colIndex, {sortElement, filterElement}) => {
        return (
          <div className='d-flex justify-content-center align-items-center flex-wrap'>
            <span className='fw-bold me-2'>Beyanname</span>
            <div className=''>{filterElement}</div>
          </div>
        )
      },
      filter: selectFilter({
        options: {
          true: 'Yüklendi',
          false: 'Yüklenmedi',
        },
        placeholder: 'Hepsi',
        defaultValue: '',
      }),
      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 d-flex justify-content-center'>
            {m.isDeclarationDocumentUploaded ? (
              <div className='btn btn-icon btn-success btn-sm'>
                <i className='bi bi-check-lg fs-4'></i>
              </div>
            ) : (
              <div className='btn btn-icon btn-danger btn-sm'>
                <i className='bi bi-dash-lg fs-4'></i>
              </div>
            )}
          </div>
        </>
      ),
    },
    {
      dataField: 'declarationDocumentUrl',
      text: 'Beyanname İşlem',
      sort: true,
      headerStyle: {width: '15%', verticalAlign: 'middle'},
      headerClasses: 'text-center ',
      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 d-flex justify-content-center'>
            {m.isDeclarationDocumentUploaded ? (
              <a href={m.declarationDocumentUrl ?? ''} className='btn btn-icon btn-info btn-sm'>
                <i className='bi bi-download fs-4'></i>
              </a>
            ) : (
              <div>
                <BasePopup
                  title='DOKUMAN_YUKLE'
                  size='lg'
                  modalOpener={
                    <div className='btn btn-icon btn-primary btn-sm'>
                      <i className='bi bi-upload fs-4'></i>
                    </div>
                  }
                >
                  {(providers: PopupProvides) => {
                    return (
                      <FileUploadForm
                        handleClose={async () => {
                          await loadReport(initFilterValues)
                          providers.handleClose()
                        }}
                        documentTypeId={m.declarationDocumentTypeId ?? 0}
                        companyGuidId={m.companyGuidId}
                      />
                    )
                  }}
                </BasePopup>
              </div>
            )}
          </div>
        </>
      ),
    },
    {
      dataField: 'a',
      text: '',
      sort: true,
      headerStyle: {width: '10%'},

      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <></>
      ),
    },
    {
      dataField: 'isInvoiceDocumentUploaded',
      text: 'Fatura Yüklendi',
      sort: true,
      headerStyle: {width: '20%'},
      headerFormatter: (column, colIndex, {sortElement, filterElement}) => {
        return (
          <div className='d-flex justify-content-center align-items-center flex-wrap'>
            <span className='fw-bold me-2'>Fatura</span>
            <div className=''>{filterElement}</div>
          </div>
        )
      },
      filter: selectFilter({
        options: {
          true: 'Yüklendi',
          false: 'Yüklenmedi',
        },
        placeholder: 'Hepsi',
        defaultValue: '',
      }),
      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 d-flex justify-content-center'>
            {m.isInvoiceDocumentUploaded ? (
              <div className='btn btn-icon btn-success btn-sm'>
                <i className='bi bi-check-lg fs-4'></i>
              </div>
            ) : (
              <div className='btn btn-icon btn-danger btn-sm'>
                <i className='bi bi-dash-lg fs-4'></i>
              </div>
            )}
          </div>
        </>
      ),
    },
    {
      dataField: 'invoiceDocumentUrl',
      text: 'Fatura İşlem',
      sort: true,
      headerClasses: 'text-center ',
      headerStyle: {width: '15%', verticalAlign: 'middle'},
      formatter: (cell: any, m: CompanyMonthlyDocumentInfo, rowIndex: number, colIndex: number) => (
        <>
          <div className='text-dark fw-bold d-block fs-6 d-flex justify-content-center'>
            {m.isInvoiceDocumentUploaded ? (
              <a href={m.invoiceDocumentUrl ?? ''} className='btn btn-icon btn-info btn-sm'>
                <i className='bi bi-download fs-4'></i>
              </a>
            ) : (
              <div>
                <BasePopup
                  title='DOKUMAN_YUKLE'
                  size='lg'
                  modalOpener={
                    <div className='btn btn-icon btn-primary btn-sm'>
                      <i className='bi bi-upload fs-4'></i>
                    </div>
                  }
                >
                  {(providers: PopupProvides) => {
                    return (
                      <FileUploadForm
                        handleClose={async () => {
                          await loadReport(initFilterValues)
                          providers.handleClose()
                        }}
                        documentTypeId={m.invoiceDocumentTypeId ?? 0}
                        companyGuidId={m.companyGuidId}
                      />
                    )
                  }}
                </BasePopup>
              </div>
            )}
          </div>
        </>
      ),
    },
  ]

  const loadReport = async (payload: CompanyMonthlyDocumentRequest) => {
    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_GetMonthlyDocumentsPageData,
        body: payload,
      })
    )
      .unwrap()
      .then(async function (response: CompanyMonthlyDocumentsPageDTOApiData) {
        setReport(response.data)
      })
  }

  useEffect(() => {
    loadReport(initFilterValues)
  }, [])

  return (
    <div>
      <div className='card card-stretch card-border'>
        <div className='card-header pt-5 d-flex justify-content-center'>
          <FormikForm initialValues={initFilterValues} onSubmit={loadReport}>
            {(props) => {
              return (
                <>
                  <div className='row'>
                    <div className='d-flex flex-column mb-3 fv-row col-xl-2'>
                      <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                        <span className=''>Ay</span>
                      </label>
                      <Field
                        placeholder=''
                        type='date'
                        autoComplete='off'
                        name={'month'}
                        className='form-control me-2 col'
                      />
                    </div>

                    <div className='d-flex mb-3 fv-row col-xl-2 align-items-end'>
                      <button type='submit' className='btn btn-lg btn-primary me-3 col-12'>
                        <span className='indicator-label'>Filtrele</span>
                      </button>
                    </div>
                  </div>
                </>
              )
            }}
          </FormikForm>
        </div>

        <div className='card-body px-0 py-3'>
          <div className='table-responsive'>
            <div>
              {(report?.companies?.length ?? 0) > 0 && (
                <BootstrapTable
                  keyField='companyGuidId'
                  data={report?.companies ?? []}
                  columns={columns}
                  filter={filterFactory()}
                  classes='table table-hover table-responsive table-row-bordered border-dark table-rounded gx-5'
                  headerClasses='table-header fw-bolder fs-5'
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MonthlyDocumentReportPage
